import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearUser } from "../../store/slices/userSlice";
import { setActiveWorkspaceFromToken } from "../../store/slices/workspaceSlice";

const LogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Clear localStorage
    localStorage.removeItem("pulselabs_user");
    localStorage.removeItem("pulselabs_workspace");

    // Clear Redux state
    dispatch(clearUser());
    dispatch(setActiveWorkspaceFromToken({ workspaceId: -1, token: "" }));

    // Navigate to home
    navigate("/");
  }, [navigate, dispatch]);

  return null;
};

export default LogoutPage;
